module.exports = __webpack_public_path__ + "img/google_play_download.f5c77124.png";